module.exports = __webpack_public_path__ + "static/media/food-active.74887929.svg";